import Series from '@src/resources/Series';

export const redirect = (basePath: string, id: string, data: any) =>
  `/${Series.name}/${data.series_id}/show/prices`;
